import apiClient from './apiClient'

const base = '/api/ResellerInvoices'
export const getResellerInvoiceCount = () => apiClient.get(`${base}/GetNewCount`)
export const getResellerNewInvoicesPrint = () => apiClient.get(`${base}/GetNewInvoicesPrint`)
export const postResellerEmailNewInvoices = () => apiClient.post(`${base}/EmailNewInvoices`)
export const postResellerConfirmNewInvoices = (payload) => apiClient.post(`${base}/ConfirmNewInvoices`, payload)
